// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"Requests_blockClick_2UKOe"};